import useIsCorpView from "./useIsCorpView"
import { useAppSelector } from "../redux/store"
import { selectLoadingState } from "../redux/customer"
import { selectChildCustomerLoadingState } from "../redux/childCustomer"

const useCustomerLoading = () => {
  const isCorpView = useIsCorpView()

  const loadingState = {
    practice: useAppSelector(selectLoadingState),
    child: useAppSelector(selectChildCustomerLoadingState),
  }
  
  return isCorpView
    ? loadingState.child
    : loadingState.practice
}

export default useCustomerLoading
